// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qlrpwhqfadwshxdtzqix.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFscnB3aHFmYWR3c2h4ZHR6cWl4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgxODYxOTAsImV4cCI6MjA1Mzc2MjE5MH0.KvPqKHe1ShdPytXMtq4pxeBunOZUJLMhX_-mRnbWjfU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);